var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAguaCorporalImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.056,
    height: 20.546,
    viewBox: "0 0 15.056 20.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12766",
    "data-name": "Group 12766",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7312",
    "data-name": "Path 7312",
    d: "M4109.393,733.985c-.2-.026-.4-.044-.6-.078a6.927,6.927,0,0,1-5.727-4.858,6.17,6.17,0,0,1,.235-4.483,26.156,26.156,0,0,1,2.156-4.111c1.214-1.9,2.473-3.773,3.717-5.654a.678.678,0,0,1,1.186-.022c1.693,2.551,3.488,5.037,4.937,7.743a15.562,15.562,0,0,1,1.3,3.081,5.385,5.385,0,0,1,.1,2.51,7,7,0,0,1-4.19,5.305,6.168,6.168,0,0,1-2.209.538,1.049,1.049,0,0,0-.147.03Zm.381-17.608c-.033.042-.057.069-.077.1-1.011,1.533-2.04,3.054-3.025,4.6a24.456,24.456,0,0,0-2.021,3.774,5.3,5.3,0,0,0-.455,3.025,5.647,5.647,0,0,0,10.953.81,4.662,4.662,0,0,0,.079-2.9,17.309,17.309,0,0,0-1.612-3.463c-1.155-2.006-2.47-3.91-3.755-5.832C4109.836,716.455,4109.809,716.422,4109.773,716.377Z",
    transform: "translate(-4102.747 -714.439)",
    fill: "#394f65",
    stroke: "#394f65",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7313",
    "data-name": "Path 7313",
    d: "M4206.817,860.33a4.68,4.68,0,0,1-2.3,3.762.7.7,0,1,1-.735-1.19,3.372,3.372,0,0,0,1.617-2.274,4.055,4.055,0,0,0,.06-.414c.052-.459.348-.752.729-.711A.7.7,0,0,1,4206.817,860.33Z",
    transform: "translate(-4195.94 -848.364)",
    fill: "#394f65",
    stroke: "#394f65",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAguaCorporalImage);
export default __webpack_public_path__ + "static/media/agua_corporal_image.7df7e95fe9ddda3f4bb62a96c77aec19.svg";
export { ForwardRef as ReactComponent };